import httpClient from "@/_shared/http-client";
import urlBuilder from "@/user/api-services/_urlBuilder";

import { objectHelper, date, httpHelper } from "@/_shared/utils";
import { roles } from "@/_shared/constants";
import { useRoleIdentifier } from "@/_shared/mixins/useRoleIdentifier";
import { generators } from "@/user/utils";

const handleUser = (httpMethod = 'post') => async (form, params) => {
  form = objectHelper.createCopy(form);
  form.user.login = generators.generateLogin(form);
  form.user.image_name = form.image_name;
  form.type = 'user';

  if (params.saveOldPassword) {
    delete form.user.password;
  }
  const currentRole = roles[form.user.role_id];
  const isVip = useRoleIdentifier.methods.checkVipRole(currentRole);
  if (!params.saveOldPassword && !form.user.password || !isVip) {
    form.user.password = null;
  }

  if (httpMethod === 'post') {
    form.user.authorized_at = date.getIsoString();
  }
  form.user = httpHelper.addDateField(form.user, httpMethod);

  const url = `${process.env.BACKEND_URL}/users`;
  const response = await httpClient[httpMethod](url, form).catch(({ response }) => {
    throw new Error(response.data.message)
  });
  return response;
};

const getUser = async (id = 1) => {
  let results = {};
  const url = urlBuilder.buildForUserForm(id);
  await httpClient
    .get(url)
    .then(({ data }) => {
      results = data.record;
      results.user.password = "";
    })
    .catch(({ response }) => {
      throw new Error(response.data.message)
    });
  return results;
};

export const userService = {
  add: handleUser('post'),
  get: getUser,
  edit: handleUser('patch'),
};



// WEBPACK FOOTER //
// ./src/user/api-services/userService.js